import PercentageBox from './PercentageBox';

export default PercentageBox;